module.exports = __webpack_public_path__ + "static/img/preview-02.d4f56935.webp";